module.exports = "/_next/static/images/video_id_7134026786559561006-f8569e80cc6910c872db19f8b79c0f30.jpg";